import { BaseModel } from '../../_base/crud';

export class WeightMeter extends BaseModel {
    id: number;
    create_uid: number;
    write_uid: number;
    create_date: any;
    write_date: any;
    company_id: number;
    name:string;
    harvest:number;
    starting_time: any;
    ending_time: any;
    product_variety_id: number;
    product_variety_name: string;
    quartel_name: string;
    quartel_id: number;
    product_type_id: number;
    product_type_name: string;
    machine_type_name: string;
    machine_type_id: number;
    machine_tech_type_name: string;
    machine_tech_type_id: number;
    machine_name: string;
    sile_id: number;
    status: boolean;

    clear(){
        this.id                     = undefined;
        this.name                   = "";
        this.harvest                = undefined;
        this.product_variety_id     = undefined;
        this.product_variety_name   = "";
        this.create_uid             = undefined;
        this.write_uid              = undefined;
        this.create_date            = undefined;
        this.write_date             = undefined;
        this.harvest                = undefined;
        this.quartel_name           = "";
        this.quartel_id             = undefined;
        this.product_type_id        = undefined;
        this.product_type_name      = "";
        this.machine_type_name      = "";
        this.machine_type_id        = undefined;
        this.machine_tech_type_name = "";
        this.machine_tech_type_id   = undefined;
        this.machine_name           = "";
        this.sile_id                = undefined;
        this.starting_time          = undefined;
        this.ending_time            = undefined;
        this.status                 = undefined;
        this.company_id             = undefined;
    }
}